import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {NineToFive} from "../../NineToFive";
import {gsap} from "gsap";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";
import {NineToFiveScatterSymbol} from "../../reels/symbols/ScatterSymbol";
import {NineToFiveBaseGameReelView} from "../../reels/NineToFiveBaseGameReelView";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreeSpinsIntro implements SimplePresentation {

    name:string = "FreesSpinIntro";

    constructor() {

    }

    public shouldRun():boolean {
        return !NineToFive.model.data.brokeTheBank &&
            NineToFive.model.data.mode == GameMode.NORMAL &&
            (NineToFive.model.data.nextMode == GameMode.FREESPIN || NineToFive.model.data.nextMode == GameMode.FREESPIN_SUPER);
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        NineToFive.autoPlayPlugin.turnOffAutoplayOnBonus();

        tl.add(NineToFive.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "S").map((sym) => {
            return (<NineToFiveScatterSymbol>sym).getActivateAnimation();
        }))
        tl.add(() => {NineToFive.soundPlayer.playSound("fsSfsActivation")}, '<');
        tl.add(() => {
            NineToFive.xBetView.removeButton(false)
            NineToFive.baseGameReelView.disableXBetReel();
            NineToFive.baseGameReelView.setFreeSpinsReelSet();
            NineToFive.popUpView.hidePopUp();
        });
        if (NineToFive.model.data.nextMode == GameMode.FREESPIN) {
            tl.add(NineToFive.transitionScreen.showIntro(), '<');
            tl.add(() => {NineToFive.soundPlayer.playLoopingSound("loaderLoop")}, '<');
        } else {
            tl.add(NineToFive.transitionScreen.showIntroSuper(), '<');
            tl.add(() => {NineToFive.soundPlayer.playLoopingSound("sfsIntroLoop")}, '<');
        }
        tl.add(() => {NineToFive.soundPlayer.playSound("introOneShot")}, '<');
        tl.add(() => NineToFive.soundPlayer.fadeOutMusic(), '<');
        tl.add(NineToFive.keypadPlugin.hide(0.1), '<');
        tl.add(NineToFive.transitionScreen.enableButton(() => this.onButtonClick(controller)), '<0.1');
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            NineToFive.keypadPlugin.setZeroBetSpinCounter(NineToFive.model.data.freespinsLeft);
            NineToFive.keypadPlugin.show(0.1);
        });
        tl.add(NineToFive.baseGameReelView.freespinMultiplier.reset());
        // TODO maybe put into a method for consistencys sake
        tl.add(() => {NineToFive.baseGameReelView.freespinMultiplier.visible = true});
        if (NineToFive.model.data.nextMode == GameMode.FREESPIN) {
            tl.add(NineToFive.baseGameReelView.freespinMultiplier.setVisualToFreespins());
            tl.add(NineToFive.backgroundElements.setToFreespins());
            tl.add(NineToFive.transitionScreen.hideIntro(), '<');
            tl.add(() => {
                NineToFive.soundPlayer.stopSound("loaderLoop");
                NineToFive.soundPlayer.switchMusic(GameMode.FREESPIN);
            }, '<')
        } else {
            tl.add(NineToFive.baseGameReelView.freespinMultiplier.setVisualToSuperFreespins());
            tl.add(NineToFive.backgroundElements.setToSuperFreespins());
            tl.add(NineToFive.transitionScreen.hideIntroSuper(), '<');
            tl.add(() => {
                NineToFive.soundPlayer.stopSound("sfsIntroLoop");
                NineToFive.soundPlayer.switchMusic(GameMode.FREESPIN_SUPER)
            }, '<')
        }
        tl.add(() => NineToFive.soundPlayer.fadeInMusic(), '<');
        tl.add(() => controller.finish());

    }
}